/* lua.js generated code 0.3.0 */

// require("clover/payment/PaymentManager")
PaymentLimitLogic = table()
var IngameLimitCache = table()
function getLimitConfig() {
    var ingameLimit = UserManager.getInstance().ingameLimit
    if (type(ingameLimit) === "string") {
        if (!IngameLimitCache[ingameLimit]) {
            IngameLimitCache[ingameLimit] = parseIngameLimitDict(ingameLimit)
        }
        return IngameLimitCache[ingameLimit]
    } else {
        var limitConfig = MetaManager.getInstance().global.ingame_limit
        return limitConfig
    }
}
// 当前支付方式是不是需要限额
PaymentLimitLogic.isNeedLimit = function (paymentType) {
    var self = this
    var limitConfig = getLimitConfig()
    cc.log(table.tostring(limitConfig))
    return paymentType === Payments.WO3PAY || limitConfig[paymentType] != null
}
// 当前支付方式是不是超过限额
function getPaymentInfosPath() {
    var __VA_ARG = $slice(arguments, 0)
    return he.HeResPathUtils.getUserDataPath() + "/" + "PaymentLimit_" + he.MetaInfo.getInstance().getImsi()
}
var caches = table()
function read() {
    var __VA_ARG = $slice(arguments, 0)
    if (caches[getPaymentInfosPath()]) {
        return caches[getPaymentInfosPath()]
    }
    var ret = table()
    var file = io.open(getPaymentInfosPath(), "r")
    if (file) {
        var data = file.read("*a")
        file.close()
        if (data) {
            ret = table.deserialize(data) || table()
        }
    }
    caches[getPaymentInfosPath()] = ret
    return ret
}
function write(d) {
    var file = io.open(getPaymentInfosPath(), "w")
    if (file) {
        file.write(table.serialize(d || table()))
        file.close()
    }
}
function getPaymentInfo(paymentType) {
    // local paymentInfo = UserManager:getInstance().paymentInfos[paymentType] 
    var paymentInfos = read()
    var paymentInfo = paymentInfos[paymentType]
    if (paymentInfo) {
        var last = os.date("*t", (paymentInfo.lastModify || 0) / 1000)
        var now = os.date("*t", Localhost.time() / 1000)
        if (now.year > last.year || now.month > last.month || now.day > last.day) {
            paymentInfo.daily = 0
        }
        if (now.year > last.year || now.month > last.month) {
            paymentInfo.monthly = 0
        }
    } else {
        paymentInfo = table(
            [1, "daily", 0],
            [1, "monthly", 0],
            [1, "lastModify", Localhost.time()]
        )
        paymentInfos[paymentType] = paymentInfo
    }
    cc.log("paymentInfos", table.tostring(paymentInfos))
    // FIXME: multi result
    return [paymentInfo, paymentInfos]
}
PaymentLimitLogic.fixPaymentType = function (paymentType) {
    var self = this
    // 三网融合限额以当前运营商为准进行计算
    var operator = GameProxy.getInstance().getOperator()
    if (paymentType === Payments.WO3PAY) {
        var operator = GameProxy.getInstance().getOperator()
        if (operator === TelecomOperators.CHINA_MOBILE) {
            return Payments.CHINA_MOBILE
        } else if (operator === TelecomOperators.CHINA_UNICOM) {
            return Payments.CHINA_UNICOM
        } else if (operator === TelecomOperators.CHINA_TELECOM) {
            return Payments.CHINA_TELECOM
        }
    }
    return paymentType
}
PaymentLimitLogic.getPaymentLimitInfo = function (paymentType) {
    var self = this
    var limitConfig = getLimitConfig()
    paymentType = self.fixPaymentType(paymentType)
    if (limitConfig[paymentType]) {
        var paymentInfo = getPaymentInfo(paymentType)
        var daily = table([1, "used", paymentInfo.daily], [1, "limit", limitConfig[paymentType].daily])
        var monthly = table([1, "used", paymentInfo.monthly], [1, "limit", limitConfig[paymentType].monthly])
        return table([1, "daily", daily], [1, "monthly", monthly])
    } else {
        return false
    }
}
PaymentLimitLogic.isExceedDailyLimit = function (paymentType) {
    var self = this
    var limitConfig = getLimitConfig()
    paymentType = self.fixPaymentType(paymentType)
    if (limitConfig[paymentType]) {
        var paymentInfo = getPaymentInfo(paymentType)
        return paymentInfo.daily >= limitConfig[paymentType].daily
    } else {
        return false
    }
}
PaymentLimitLogic.isExceedMonthlyLimit = function (paymentType) {
    var self = this
    var limitConfig = getLimitConfig()
    paymentType = self.fixPaymentType(paymentType)
    if (limitConfig[paymentType]) {
        var paymentInfo = getPaymentInfo(paymentType)
        return paymentInfo.monthly >= limitConfig[paymentType].monthly
    } else {
        return false
    }
}
// 
PaymentLimitLogic.buyComplete = function (paymentType, price) {
    var self = this
    require("hecore/debug/remote")
    RemoteDebug.uploadLog("PaymentLimitLogic:buyComplete", tostring(paymentType), tostring(price), table.tostring(PaymentLimitLogic.getPaymentLimitInfo(paymentType)), debug.traceback())
    var limitConfig = getLimitConfig()
    paymentType = self.fixPaymentType(paymentType)
    if (limitConfig[paymentType]) {
        var [paymentInfo, paymentInfos] = getPaymentInfo(paymentType)
        paymentInfo.daily = paymentInfo.daily + price
        paymentInfo.monthly = paymentInfo.monthly + price
        paymentInfo.lastModify = Localhost.time()
        write(paymentInfos)
    }
}
